<template>

    <div class="main-content" >
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item>
                <el-input v-model="dataForm.searchKey" placeholder="请输入关键字" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="getDataList()">查询</el-button>
                <el-button size="small" type="primary"
                           v-if="hasBtnPermission('btn_jz_pm_databases_add')"
                           @click="addOrUpdateHandle()">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table
                :data="dataList"
                border
                :height="tableMaxHeight"
                v-loading="dataListLoading"
                @selection-change="selectionChangeHandle"
                style="width: 100%;">
            <el-table-column
                    fixed
                    type="index"
                    header-align="center"
                    align="left"
                    label="序号"
                    width="60"
                    :index="getRowsIndex"
            >
            </el-table-column>
            <el-table-column
                    prop="title"
                    header-align="center"
                    align="left"
                    width="150"
                    label="数据源名称">
            </el-table-column>
            <el-table-column
                    prop="id"
                    header-align="center"
                    align="center"
                    width="100"
                    label="数据源类型">
                <template slot-scope="scope">
                    <el-tag size="small">MySql</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                    prop="url"
                    header-align="center"
                    align="left"
                    min-width="300"
                    label="连接信息" :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    header-align="center"
                    align="center"
                    width="180"
                    label="创建时间">
            </el-table-column>
            <el-table-column
                    fixed="right"
                    header-align="center"
                    align="center"
                    width="150"
                    label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small"
                               v-if="hasBtnPermission('btn_jz_pm_databases_add')"
                               @click="addOrUpdateHandle(scope.row.id)">修改</el-button>
                    <el-button type="text" size="small"
                               v-if="hasBtnPermission('btn_jz_pm_databases_delete')"
                               @click="deleteHandle(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <el-pagination
                @size-change="sizeChangeHandle"
                @current-change="currentChangeHandle"
                :current-page="pageIndex"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :total="totalPage"
                layout="total, sizes, prev, pager, next, jumper">
        </el-pagination> -->
        <pagination
            class="limit"
            :page-sizes="[10, 20, 50, 100]"
            :total="totalPage"
            :page.sync="pageIndex"
            :limit.sync="pageSize"
            @pagination="paginationChange">
        </pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</template>

<script>
    import AddOrUpdate from './edit'
    import Pagination from '@/components/Pagination.vue';
    export default {
        props: ['mainContentViewHeight'],
        data() {
            return {
                dataForm: {
                    searchKey: ''
                },
                dataList: [],
                tableMaxHeight: document.documentElement.clientHeight - 252,
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false
            }
        },
        components: {
            AddOrUpdate,
            Pagination
        },
        activated() {
            this.getDataList()
        },
        mounted() {
            const that = this;
            let resizeTag = true
            window.onresize = () => {
                if (resizeTag) { //防抖动
                    that.ifmove();
                    resizeTag = false
                    setTimeout(() => {
                        resizeTag = true
                    }, 1000)
                }
            }
            that.ifmove();
        },
        methods: {
            ifmove() {
                let tableMaxHeight = document.documentElement.clientHeight - 310;
                this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
                this.$nextTick(() => {
                    this.tableMaxHeight = tableMaxHeight
                })
                // this.getDataList()
            },
            // 获取数据列表
            getDataList() {
                this.pageIndex = 1;
                this.dataListLoading = true
                this.$http.post(this.$http.adornUrl('/customform/datasourceconfig/list'), {
                    'page': this.pageIndex,
                    'rows': this.pageSize,
                    'searchKey': this.dataForm.searchKey,
                    'filter': {}
                },{baseURL: ''}).then(({data}) => {
                    if (data) {
                        this.dataList = data.rows
                        this.totalPage = data.totalItemCount
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            getRowsIndex(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            paginationChange(obj){
                this.pageIndex= obj.page||1
                this.pageSize=obj.limit||10
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增 / 修改
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id)
                })
            },
            // 删除
            deleteHandle(id) {
                this.$confirm(`确定要删除该数据?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http({
                        url: this.$http.adornUrl('/customform/datasourceconfig/delete'),
                        method: 'post',
                        baseURL: '',
                        data: {
                            'id': id,
                        }
                    }).then(({data}) => {
                        if (data && data.code === '1') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>
